export default __webpack_public_path__ + "static/media/wQ.b069e38b.svg";